import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { getTestIds } from 'seagull/utils/TestIds';
import { useResponsive } from '~/client-flow/contexts';
import { useOverlayContext, useStore } from '~/contexts';
import { useOnMount } from '~/hooks/useOnMount';
import { fullName } from '~/infra/utils';
import { selectors } from '~/store/state-selectors';
import { CoverPageDesktop } from './CoverPageDesktop';
import { CoverPageMobile } from './CoverPageMobile';
export const GetCoverPageTID = (parentTestId)=>getTestIds({
        parentTestId
    });
export const CoverPage = (param)=>{
    let { testId, relationship, onGetStarted, isPreview, showRecipientToast } = param;
    const { CoverPageTestIds } = useMemo(()=>GetCoverPageTID(testId), [
        testId
    ]);
    const { isMobile } = useResponsive();
    const userFirstName = useStore(selectors.user.firstName);
    const userLastName = useStore(selectors.user.lastName);
    const viewerName = useMemo(()=>{
        var _fullName;
        return (_fullName = fullName(userFirstName !== null && userFirstName !== void 0 ? userFirstName : null, userLastName !== null && userLastName !== void 0 ? userLastName : null)) !== null && _fullName !== void 0 ? _fullName : '';
    }, [
        userFirstName,
        userLastName
    ]);
    const { showInfoToast } = useOverlayContext();
    useOnMount(()=>{
        if (showRecipientToast) {
            showInfoToast("You're reviewing the proposal as ".concat(viewerName), CoverPageTestIds.RecipientToast());
        }
    });
    if (isMobile) {
        return /*#__PURE__*/ _jsx(CoverPageMobile, {
            testId: testId,
            relationship: relationship,
            onGetStarted: onGetStarted,
            isPreview: isPreview
        });
    }
    return /*#__PURE__*/ _jsx(CoverPageDesktop, {
        testId: testId,
        relationship: relationship,
        onGetStarted: onGetStarted,
        isPreview: isPreview
    });
};
